import { getAttribution } from './attributionStore';

/**
 * Flattens the stored Google Ads attribution into the snake_case keys used in
 * analytics event payloads (`gclid`, `utm_source`, …). Only keys with a value
 * are included, so an event fired with no attribution carries no empty fields.
 *
 * Shared by the internal `booking_completed` event (RudderStack et al.) and
 * kept in the same shape the GA `book_appointment` payload uses, so a booking's
 * attribution reads identically across destinations.
 */
export const getAttributionTrackingParams = (): Record<string, string> => {
  const attribution = getAttribution();
  if (!attribution) return {};
  const params: Record<string, string> = {};
  if (attribution.gclid) params.gclid = attribution.gclid;
  if (attribution.gbraid) params.gbraid = attribution.gbraid;
  if (attribution.wbraid) params.wbraid = attribution.wbraid;
  if (attribution.utmSource) params.utm_source = attribution.utmSource;
  if (attribution.utmMedium) params.utm_medium = attribution.utmMedium;
  if (attribution.utmCampaign) params.utm_campaign = attribution.utmCampaign;
  if (attribution.utmTerm) params.utm_term = attribution.utmTerm;
  if (attribution.utmContent) params.utm_content = attribution.utmContent;
  return params;
};
